import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";

export default function MagicLogin() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [state, setState] = useState({ status: "verifying", error: null });

  useEffect(() => {
    const token = sp.get("token");
    if (!token) { setState({ status: "error", error: "Missing token" }); return; }
    api.post("/auth/magic-link/exchange", { token })
      .then(({ data }) => {
        localStorage.setItem("pulse_token", data.access_token);
        localStorage.setItem("pulse_user", JSON.stringify(data.user));
        setUser?.(data.user);
        setState({ status: "success" });
        setTimeout(() => {
          if (data.user.role === "super_admin") navigate("/super-admin");
          else if (data.user.role === "patient") navigate("/patient");
          else navigate("/clinic");
        }, 700);
      })
      .catch((e) => setState({ status: "error", error: e?.response?.data?.detail || "Link expired or already used" }));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center app-bg">
      <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-md w-full text-center" data-testid="magic-login-card">
        {state.status === "verifying" && (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-[#004a99] mx-auto" />
            <h1 className="text-xl font-heading font-bold mt-4">Verifying your one-tap link…</h1>
            <p className="text-sm text-slate-500 mt-1">Hang tight, signing you in securely.</p>
          </>
        )}
        {state.status === "success" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
            <h1 className="text-xl font-heading font-bold mt-4">Logged in! Redirecting…</h1>
          </>
        )}
        {state.status === "error" && (
          <>
            <AlertTriangle className="h-12 w-12 text-red-600 mx-auto" />
            <h1 className="text-xl font-heading font-bold mt-4">Link expired</h1>
            <p className="text-sm text-slate-500 mt-2" data-testid="magic-login-error">{typeof state.error === "string" ? state.error : "This link is no longer valid."}</p>
            <button onClick={() => navigate("/login")} className="mt-4 text-[#004a99] underline">Sign in with email & password →</button>
          </>
        )}
      </div>
    </div>
  );
}
